import type { IntlShape } from 'react-intl'
import type { MeterReadingFormHeader, MeterReadingHeader } from './types'

export const meterReadingHeaders: MeterReadingHeader[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'UUID',
				description: 'Table column header for meter reading: UUID',
			}),
		key: 'uuid',
		show: false,
		sortable: true,
		type: 'text',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Mittari',
				description: 'Table column header for meter reading: Meter',
			}),
		key: 'meter',
		show: true,
		sortable: true,
		type: 'meter',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Arvo',
				description: 'Table column header for meter reading: Value',
			}),
		key: 'value',
		show: true,
		sortable: true,
		type: 'text',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Status',
				description: 'Table column header for meter reading: Status',
			}),
		key: 'status',
		show: true,
		sortable: true,
		type: 'statusOptions',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Mittauspäivä',
				description: 'Table column header for meter reading: Date',
			}),
		key: 'date',
		show: true,
		sortable: true,
		type: 'date',
	},
]

export const meterReadingFormHeaders: MeterReadingFormHeader[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Mittari',
				description: 'Table column header for meter reading form: Meter',
			}),
		key: 'meterUUID',
		show: true,
		required: true,
		type: 'meterOptions',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Status',
				description: 'Table column header for meter reading form: Status',
			}),
		key: 'status',
		show: true,
		required: true,
		type: 'statusOptions',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Päivämäärä',
				description: 'Table column header for meter reading form: Date',
			}),
		key: 'date',
		show: true,
		required: true,
		type: 'date',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Arvo',
				description: 'Table column header for meter reading form: Value',
			}),
		key: 'value',
		show: true,
		required: true,
		type: 'number',
	},
]
